import { render } from "./TextBoxMask.vue?vue&type=template&id=4b738cc1&scoped=true&ts=true"
import script from "./TextBoxMask.vue?vue&type=script&lang=ts"
export * from "./TextBoxMask.vue?vue&type=script&lang=ts"

import "./TextBoxMask.vue?vue&type=style&index=0&id=4b738cc1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b738cc1"]])

export default __exports__